import {Component, OnInit} from '@angular/core';
import { SessionService } from '@edl-development/edl-common';
@Component({
    templateUrl: './login-shell.component.html',
    styleUrls: ['./login-shell.component.scss']
})
export class LoginShellComponent implements OnInit{

    constructor(
        public sessionService: SessionService
    ){ }

    ngOnInit() {

    }
}